import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "reactfire";
import {
    Card,
    Spacer,
    Button,
    Input,
    Checkbox,
    CardHeader,
    CardBody,
    CardFooter,
    Divider,
    Link
} from '@nextui-org/react';
import { Auth,  GoogleAuthProvider, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithPopup, signOut } from "firebase/auth";
import { setDoc, doc, collection, getFirestore } from "firebase/firestore";
import React from "react";
import {Icon} from "@iconify/react";

export const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const auth = useAuth();
    const navigate = useNavigate();
    const onLogin = () => {
       
        signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            // Signed in
            if (userCredential.user.emailVerified) {
                navigate("/extractors")
            } else {
                signOut(auth);
                setMessage("Please verify your email address. Check your email for a link.")
            }
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log(errorCode, errorMessage)
        });

    }

    const resetPassword = () => {
        sendPasswordResetEmail(auth, email)
        .then(() => {
            setMessage("Password reset email sent!")
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            setMessage(errorMessage);
            console.log(errorCode, errorMessage)
        });
    }
  
    const signInWithGoogle = async (auth: Auth) => {
        const provider = new GoogleAuthProvider();
        try {
            const userCredentials = await signInWithPopup(auth, provider);
            const firestore = getFirestore();

            // Check if user already exists in Firestore
            const { getDoc } = await import('firebase/firestore');
            const userDoc = await getDoc(doc(collection(firestore, 'users'), userCredentials.user.uid));
            
            const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

            if (!userDoc.exists()) {
                // New user trying to sign up via Google
                if (!isDevelopment) {
                    // Production: prevent this
                    await signOut(auth);
                    setMessage("New sign ups are currently disabled. Please contact support if you need access.");
                    return;
                }
                // Development: allow new user signup
                await setDoc(doc(collection(firestore, 'users'), userCredentials.user.uid), {
                    id: userCredentials.user.uid,
                    displayName: userCredentials.user.displayName,
                    email: userCredentials.user.email,
                    photoURL: userCredentials.user.photoURL,
                    usage: 0,
                    lastLoginDate: new Date().toISOString()
                });
                navigate('/extractors');
                return;
            }

            // Existing user - allow login
            setDoc(doc(collection(firestore, 'users'), userCredentials.user.uid), {
                id: userCredentials.user.uid,
                displayName: userCredentials.user.displayName,
                email: userCredentials.user.email,
                photoURL: userCredentials.user.photoURL,
                usage: userDoc.data().usage || 0,
                lastLoginDate: new Date().toISOString()
            });
            navigate('/extractors');
        } catch (error: any) {
            console.log(error);
            setMessage("An error occurred during Google sign-in");
        }
    };

    const [isVisible, setIsVisible] = React.useState(false);

    const toggleVisibility = () => setIsVisible(!isVisible);
  
  return (
    <div className="flex h-full w-full items-center justify-center  min-h-[80vh]">
      <div className="flex w-full max-w-sm flex-col gap-4 rounded-large bg-content1 px-8 pb-10 pt-6 shadow-small">
        <p className="pb-2 text-xl font-medium">Login to DoxPro</p>
        {message && <p className="text-red-500 text-sm">{message}</p>}
        <form className="flex flex-col gap-3" onSubmit={(e) => {e.preventDefault(); onLogin()}}>
          <Input
            label="Email Address"
            name="email"
            placeholder="Enter your email"
            type="email"
            variant="bordered"
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            endContent={
              <button type="button" onClick={toggleVisibility}>
                {isVisible ? (
                  <Icon
                    className="pointer-events-none text-2xl text-default-400"
                    icon="solar:eye-closed-linear"
                  />
                ) : (
                  <Icon
                    className="pointer-events-none text-2xl text-default-400"
                    icon="solar:eye-bold"
                  />
                )}
              </button>
            }
            label="Password"
            name="password"
            placeholder="Enter your password"
            type={isVisible ? "text" : "password"}
            onChange={(e) => setPassword(e.target.value)}
            variant="bordered"
          />
          <div className="flex items-center justify-between px-1 py-2">
            <Checkbox name="remember" size="sm">
              Remember me
            </Checkbox>
            <Link className="text-default-500" href="#" size="sm" onClick={resetPassword}>
              Forgot password?
            </Link>
          </div>
          <Button color="primary" type="submit">
            Log In
          </Button>
        </form>
        <div className="flex items-center gap-4 py-2">
          <Divider className="flex-1" />
          <p className="shrink-0 text-tiny text-default-500">OR</p>
          <Divider className="flex-1" />
        </div>
        <div className="flex flex-col gap-2">
          <Button
            startContent={<Icon icon="flat-color-icons:google" width={24} />}
            variant="bordered"
            onClick={() => signInWithGoogle(auth)}
          >
            Continue with Google
          </Button>
         
        </div>
      </div>
    </div>
  );
}
